import React, { useState, useEffect } from "react";
import { Messages } from "primereact/messages";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { changePasswordService } from "../../../service/AUTH/LoginService";
import "./portal.css";
import { addDays, formatDateToken } from "../../../utilities/DateUtil";
import { TokenGenerate } from "../../../service/AUTH/TokenService";
import FooterIndex from "./FooterIndex";
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function ChangePassword() {
    const history = useHistory();
    const [data, setData] = useState({
        userId: "",
        userPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const [accessToken, setAccessToken] = useState("");
    const [errData, setErrData] = useState(null);
    const [sentGenToken] = useState({
        apiKeyId: Math.floor(1000000000 + Math.random() * 9000000000),
        createBy: (data.userId && data.userId !== '') ? data.userId : 'dev',
        createDt: formatDateToken(new Date(), true),
        desc: "Generate Access Token By Web Application",
        expireDt: formatDateToken(addDays(new Date(), 1), true), //dateToken, // dateToken.setDate(dateToken.getDate() + 1),
        remark: "Generate",
        role: "USER",
    });

    let messages = {};
    const [passType1, setPassType1] = useState("hide");
    const [passType2, setPassType2] = useState("hide");
    const [passType3, setPassType3] = useState("hide");

    useEffect(() => {
        // console.log("sentGenToken ", accessToken);
        if (accessToken !== '') {
            onChangePasswordService();
        }
    }, [accessToken]);

    // const history = useHistory();

    const onOkClick = () => {
        if (data.userId === "" || data.userPassword === "" || data.newPassword === "" || data.confirmPassword === "") {
            showMessages("กรุณาระบุข้อมูลให้ครบถ้วน");
        } else if (data.newPassword !== data.confirmPassword) {
            showMessages("รหัสผ่านใหม่ และ ยืนยันรหัสผ่าน ไม่ตรงกัน");
        } else {
            onTokenGenerate();
            // onChangePasswordService();
        }
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            onOkClick();
        }
    };

    const onTokenGenerate = async () => {
        await TokenGenerate(sentGenToken).then(
            (res) => {
                if (res !== undefined) {
                    setAccessToken(res)
                } else {
                    showMessages(`เกิดข้อผิดพลาด Status Code: ${res.status} ${res.message}`);
                }
            },
            function (err) {
                setErrData(err)
            }
        );
    };

    const showMessages = (msg, type = "error", summary = "เกิดข้อผิดพลาด :") => {
        messages.show({ severity: type, summary: summary, detail: " " + msg, life: "5000" });
    };

    const onChangePasswordService = async () => {
        let result = await changePasswordService(data, accessToken).then(
            (res) => {
                if (res !== undefined) {
                    let dataRes = res[0];
                    if (dataRes.statusCode === "C") {
                        showMessages("", "info", " สมบูรณ์ ผ่านการตรวจสิทธิ์สามารถเข้าสู่ระบบได้");
                        setData({
                            userId: "",
                            userPassword: "",
                            newPassword: "",
                            confirmPassword: "",
                        });
                    } else if (dataRes.statusCode === "E") {
                        // showMessages(" ไม่ผ่านการตรวจสิทธิ์");
                        showMessages("", "error", " ไม่ผ่านการตรวจสิทธิ์");
                    }
                } else {
                    result = "เกิดข้อผิดพลาด";
                    showMessages(" เปลี่ยนรหัสผ่านไม่สำเร็จ");
                }
            },
            function (err) {
                setErrData(err)
            }
        );
    };

    const onShowPassword1 = (type) => {
        switch (type) {
            case "show": {
                setPassType1("hide");
                break;
            }
            case "hide": {
                setPassType1("show");
                break;
            }
        }
    }
    const onShowPassword2 = (type) => {
        switch (type) {
            case "show": {
                setPassType2("hide");
                break;
            }
            case "hide": {
                setPassType2("show");
                break;
            }
        }
    }
    const onShowPassword3 = (type) => {
        switch (type) {
            case "show": {
                setPassType3("hide");
                break;
            }
            case "hide": {
                setPassType3("show");
                break;
            }
        }
    }

    return (
        <>
            <div className="login-body">
                <ValidateService err={errData} setErr={setErrData} />
                {/* <div className="login-panel"></div> */}
                <Messages ref={(el) => (messages = el)} className="show-msg" />

                <div className="login-panel"></div>
                <div className="login-content" style={{ marginTop: "2%" }}>
                    <div className="p-d-flex p-flex-column" style={{ display: "flex", justifyContent: "space-between" }}>
                        <div className="p-col-12 p-md-4" style={{ textAlign: "center" }}>
                            <img src="assets/layout/images/logo/icon.png" style={{ width: "120px" }} />
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '35px', fontWeight: 'bold' }}>ระบบบริหารจัดการงานวางท่อ</label>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '25px', fontWeight: 'bold' }}>Pipeline Management System : PMS</label>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <hr />
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column" style={{ textAlign: "center" }}>
                        <div className="p-col-12 p-md-4">
                            <label style={{ fontSize: '23px' }}>เปลี่ยนรหัสผ่าน</label>
                        </div>
                    </div>


                    {/*  */}
                    <div className="p-d-flex p-flex-column">
                        <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="p-inputgroup" style={{ width: "70%" }}>
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-user" style={{ marginRight: "7px" }}></i>
                                </span>
                                <InputText placeholder="ชื่อผู้ใช้" value={data.userId} id="userId" type="text" onChange={(e) => onInputTextChange(e, "userId")} onKeyDown={handleKeyDown} />
                            </div>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column">
                        <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="p-inputgroup" style={{ width: "70%" }}>
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-unlock" style={{ marginRight: "7px" }}></i>
                                </span>
                                <InputText placeholder="รหัสผ่าน" type={passType1 === "hide" ? "password" : "text"} id="userPassword" value={data.userPassword} onKeyDown={handleKeyDown} onChange={(e) => onInputTextChange(e, "userPassword")} />
                                <span className="p-inputgroup-addon" onClick={(e) => onShowPassword1(passType1)}>
                                    <i className={passType1 === "hide" ? "pi pi-eye-slash" : "pi pi-eye"} style={{ marginLeft: "0px" }}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column">
                        <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="p-inputgroup" style={{ width: "70%" }}>
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-key" style={{ marginRight: "7px" }}></i>
                                </span>
                                <InputText placeholder="รหัสผ่านใหม่" type={passType2 === "hide" ? "password" : "text"} id="newPassword" value={data.newPassword} onChange={(e) => onInputTextChange(e, "newPassword")} onKeyDown={handleKeyDown} />
                                <span className="p-inputgroup-addon" onClick={(e) => onShowPassword2(passType2)}>
                                    <i className={passType2 === "hide" ? "pi pi-eye-slash" : "pi pi-eye"} style={{ marginLeft: "0px" }}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="p-d-flex p-flex-column">
                        <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="p-inputgroup" style={{ width: "70%" }}>
                                <span className="p-inputgroup-addon">
                                    <i className="pi pi-key" style={{ marginRight: "7px" }}></i>
                                </span>
                                <InputText placeholder="ยืนยัน-รหัสผ่านใหม่" type={passType3 === "hide" ? "password" : "text"} id="confirmPassword" value={data.confirmPassword} onChange={(e) => onInputTextChange(e, "confirmPassword")} onKeyDown={handleKeyDown} />
                                <span className="p-inputgroup-addon" onClick={(e) => onShowPassword3(passType3)}>
                                    <i className={passType3 === "hide" ? "pi pi-eye-slash" : "pi pi-eye"} style={{ marginLeft: "0px" }}></i>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center" }}>
                        <Button
                            label="เปลี่ยนรหัสผ่าน"
                            onClick={onOkClick}
                            icon="pi pi-key"
                            iconPos="right"
                        />
                        <Button
                            label="ยกเลิก"
                            className="p-button-secondary"
                            style={{ marginLeft: '5px' }}
                            onClick={() => {
                                history.push("/login");
                            }}
                            icon="pi pi-arrow-left"
                            iconPos="right"
                        />
                    </div>
                    <div className="p-col-12 p-md-4" style={{ display: "flex", justifyContent: "center", marginTop: '20px' }}>
                        <FooterIndex />
                    </div>

                </div>

                {/* <div className="login-content">
                    <div className="p-grid crud-demo login-box">
                        <div className="p-col-12 ">
                            <div className="p-grid  p-fluid" style={{ textAlign: "center" }}>
                                <div className="p-col-12 p-md-4">
                                    <img src="assets/layout/images/logo/icon.png"
                                        style={{ width: 120, marginBottom: 0, position: 'relative' }} alt="PMS"
                                    />
                                </div>
                            </div>

                            <div className="p-grid  p-fluid" style={{ textAlign: "center" }}>
                                <div className="p-col-12 p-md-4">
                                    <h3 style={{ fontSize: 30 }}>
                                        <span><b>ระบบบริหารจัดการงานวางท่อ</b></span>
                                    </h3>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <label htmlFor="username">ชื่อผู้ใช้</label>
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="ชื่อผู้ใช้" value={data.userId} id="userId" type="text" onChange={(e) => onInputTextChange(e, "userId")} onKeyDown={handleKeyDown} />
                                        <i className="pi pi-user"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <label htmlFor="password">รหัสผ่าน</label>
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="รหัสผ่าน" type="password" id="userPassword" type="password" value={data.userPassword} onKeyDown={handleKeyDown} onChange={(e) => onInputTextChange(e, "userPassword")} />
                                        <i className="pi pi-unlock"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <label htmlFor="password">รหัสผ่านใหม่</label>
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="รหัสผ่านใหม่" type="password" id="newPassword" value={data.newPassword} onChange={(e) => onInputTextChange(e, "newPassword")} onKeyDown={handleKeyDown} />
                                        <i className="pi pi-unlock"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-4">
                                    <label htmlFor="password">ยืนยัน-รหัสผ่านใหม่</label>
                                    <div className="login-input-wrapper" style={{ width: "100%", marginBottom: "5px" }}>
                                        <InputText placeholder="ยืนยัน-รหัสผ่านใหม่" type="password" id="confirmPassword" value={data.confirmPassword} onChange={(e) => onInputTextChange(e, "confirmPassword")} onKeyDown={handleKeyDown} />
                                        <i className="pi pi-unlock"></i>
                                    </div>
                                </div>
                            </div>

                            <div className="p-grid  p-fluid">
                                <div className="p-col-12 p-md-2">
                                    <Button
                                        label="เปลี่ยนรหัสผ่าน" style={{ minWidth: 0 }}
                                        onClick={onOkClick} icon="pi pi-sign-in" iconPos="right"
                                    />
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button
                                        label="ยกเลิก"
                                        className="p-button-secondary"
                                        onClick={() => {
                                            history.push("/login");
                                        }}
                                        style={{ minWidth: 0 }}
                                        icon="pi pi-key"
                                        iconPos="right"
                                    />
                                </div>
                            </div>
                            <FooterIndex />
                        </div>
                    </div>
                </div> */}
            </div>
        </>
    );
}
